import Chip from '@mui/material/Chip';
import type { SxProps, Theme } from '@mui/material/styles';
import type React from 'react';

const FALLBACK_COLOR = '#6B7280';

interface TopicTagProps {
  topicName: string;
  color?: string | null;
  size?: 'small' | 'medium';
  onDelete?: () => void;
  inactive?: boolean;
  variant?: 'outlined' | 'filled';
  sx?: SxProps<Theme>;
  'data-tag-chip'?: true;
}

const TopicTag: React.FC<TopicTagProps> = ({
  topicName,
  color,
  size = 'small',
  onDelete,
  inactive = false,
  variant = 'outlined',
  sx,
  ...rest
}) => {
  const resolvedColor = color && !inactive ? color : FALLBACK_COLOR;

  const baseSx: SxProps<Theme> =
    variant === 'filled'
      ? {
          color: resolvedColor,
          bgcolor: `${resolvedColor}1A`,
          height: 20,
          fontSize: '0.65rem',
          fontWeight: 500,
          opacity: inactive ? 0.5 : 1,
          '& .MuiChip-label': { px: 0.75 },
        }
      : {
          color: resolvedColor,
          borderColor: resolvedColor,
          fontWeight: 500,
          opacity: inactive ? 0.5 : 1,
          '& .MuiChip-deleteIcon': {
            color: resolvedColor,
            '&:hover': {
              color: resolvedColor,
              opacity: 0.7,
            },
          },
        };

  return (
    <Chip
      label={topicName}
      size={size}
      variant={variant === 'outlined' ? 'outlined' : undefined}
      onDelete={onDelete}
      sx={[baseSx, ...(Array.isArray(sx) ? sx : [sx])]}
      {...rest}
    />
  );
};

export default TopicTag;
